// extracted by mini-css-extract-plugin
export default {"title":"certificationScope_title__5FyXo","bigFontTable":"certificationScope_bigFontTable__ZR9ua"};